import Appliances from "@/assets/images/dropdownDirectory/In-Stock-Appliances.webp";
import Dishwashers from "@/assets/images/dropdownDirectory/In-Stock-Dishwashers.webp";
import stockLaundry from "@/assets/images/dropdownDirectory/In-Stock-Laundry.webp";
import Refrigerators from "@/assets/images/dropdownDirectory/In-Stock-Refrigerators.webp";
import smartAppliances from "@/assets/images/dropdownDirectory/In-StockSmartAppliances.webp";
import LuxuryAppliances from "@/assets/images/dropdownDirectory/luxuryAppliances.webp";

import CookingAppliances from "@/assets/images/dropdownDirectory/In-Stock-CookingAppliances.webp";
import NoImage from "@/assets/images/no-image.webp";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import RightArrow from "@/icons/RightArrow";
import { cn } from "@/lib/utils";
import { useGetCategoriesQuery } from "@/redux/apiSlices/categoriesApi";
import Link from "next/link";
import { useRef, useState } from "react";
import DynamicImage from "../DynamicImages/DynamicImage";
import { useDispatch, useSelector } from "react-redux";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";

const CategoriesList = ({ callBack }) => {
  const { data } = useGetCategoriesQuery();
  const categoriesData = data?.data || [];

  const generateHref = (category, mainSlug) => {
    const { isTagged, fieldIds, fieldValueIds } = category;
    if (isTagged) {
      // Filter out undefined or null values
      const validFieldIds = fieldIds?.filter(
        (id) => id !== undefined && id !== null
      );
      const validFieldValueIds = fieldValueIds?.filter(
        (id) => id !== undefined && id !== null
      );

      // Construct the URL query only if valid values exist
      const query = [
        validFieldIds?.length ? `fieldIds=${validFieldIds.join(",")}` : null,
        validFieldValueIds?.length
          ? `fieldValueIds=${validFieldValueIds.join(",")}`
          : null,
      ]
        .filter(Boolean) // Remove null or undefined parts of the query
        .join("&");

      return query ? `${mainSlug}?${query}` : mainSlug;
    } else {
      return mainSlug;
    }
  };

  return (
    <div className="bg-light-gray">
      <div className=" max-w-1440 px-5 container  p-0 lg:px-0">
        <div className="border-l-2 border-l-white grid grid-cols-102  min-h-[78.5px] lg:hidden">
          {categoriesData.length > 0 &&
            categoriesData?.map((category) => (
              <RenderCategories
                key={category.id}
                category={category}
                generateHref={generateHref}
              />
            ))}
        </div>
        {/*mobile view */}

        <div className="hidden lg:block  bg-white">
          {categoriesData.length > 0 &&
            categoriesData.map((category) => (
              <RenderCategoriesForMobile
                key={category.id}
                category={category}
                generateHref={generateHref}
                callBack={callBack}
                className="py-4"
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default CategoriesList;

const RenderCategories = ({ category, generateHref }) => {
  const [open, setOpen] = useState(false);
  const closePopover = () => setOpen(false);
  const breadCrum = useSelector((state) => state.breadcrumbs);
  const dispatch = useDispatch();
  const disabledUrls = [
    "deals-and-clearance",
    "deals-and-clearance/deal",
    "deals-and-clearance/shop-outlet",
    "deals-and-clearance/rebate-offers",
    "smart-appliances/browse-by-feature",
  ];

  const categoryMap = {
    Refrigerators: "refrigerators-freezers",
    Dishwashers: "dishwashers/all-dishwashers",
    Cooking: "cooking/all-cooking",
    "Washers & Dryers": "laundry/all-laundry",
  };

  const hoverDelay = 1000; // Delay in milliseconds before opening popover
  const hoverTimeout = useRef(null);

  const handleMouseEnter = () => {
    hoverTimeout.current = setTimeout(() => setOpen(true), hoverDelay);
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimeout.current);
    setOpen(false);
  };

  const addBreadcrum = (category) => {
    dispatch(AddNewBreadcrum(category));
  };

  const categoryBreadcrumb = {
    name:
      category?.categoryName === "Refrigerators"
        ? "Refrigerators & Freezers"
        : category?.categoryName,
    url: category?.slug,
  };

  const bannerHref =
    category?.categoryName === "Refrigerators"
      ? "/refrigerators/all-refrigerators?page=1&isAvailabilty=true"
      : category?.categoryName === "Dishwashers"
      ? "/dishwashers?page=1&isAvailabilty=true"
      : category?.categoryName === "Cooking"
      ? "/cooking?page=1&isAvailabilty=true"
      : category?.categoryName === "Washers & Dryers"
      ? "/laundry?page=1&isAvailabilty=true"
      : category?.categoryName === "Smart Appliances"
      ? "/smart-appliances?page=1&isAvailabilty=true"
      : category?.categoryName === "Deals & Clearance"
      ? "/in-stock"
      : "";

  const bannerLabel =
    category?.categoryName === "Refrigerators"
      ? "In-Stock Refrigerators"
      : category?.categoryName === "Dishwashers"
      ? "In-Stock Dishwashers"
      : category?.categoryName === "Cooking"
      ? "In-Stock Cooking Appliances"
      : category?.categoryName === "Washers & Dryers"
      ? "In-Stock Laundry"
      : category?.categoryName === "Smart Appliances"
      ? "In-Stock Smart Appliances"
      : category?.categoryName === "Deals & Clearance"
      ? "In-Stock Appliances"
      : "";

  return (
    <Popover key={category?.id} open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        asChild
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {category?.subCategoryCounts === 0 ? (
          <Link
            className={cn(
              "flex flex-col justify-center place-items-center p-p10 cursor-pointer border-r-2 border-r-white border-b-2 border-b-transparent "
            )}
            href={`/${category?.slug}`}
            onClick={() => {
              addBreadcrum([categoryBreadcrumb]);
            }}
          >
            <DynamicImage
              alt={category?.categoryName}
              src={category?.categoryImages?.[0]?.url || NoImage.src}
              disableIsBlur
              width={25}
              height={25}
              className="min-h-[25px] max-h-25px"
            />
            <button className=" mt-1">{category?.categoryName}</button>{" "}
          </Link>
        ) : (
          <div
            className={cn(
              "grid place-content-center place-items-center p-p10 cursor-pointer border-r-2 min-h-[97px] border-r-white border-b-2 border-b-transparent ",
              open && " border-b-2 border-b-black "
            )}
          >
            <DynamicImage
              alt={category?.categoryName}
              src={category?.categoryImages?.[0]?.url || NoImage.src}
              width={25}
              height={25}
              className="min-h-[25px] max-h-25px"
            />
            <button className=" mt-1">{category?.categoryName}</button>
          </div>
        )}
      </PopoverTrigger>
      {category?.subcategories.length > 0 && (
        <PopoverContent
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          className=" w-100vw bg-transparent  my-0 mx-auto right-0 shadow-none border-0 top[-4px] "
        >
          <div style={{ height: "100vh" }}>
            <div className="container bg-white lg:h-full">
              <div className="flex max-w-[1440px] my-0 mx-auto  px-5 items-start ">
                <div className=" flex-1  pr-7 pb-4 lg:pr-0 lg:border-0">
                  <div className=" flex justify-between items-center pt-5 pb-p18 border-b border-gray1 lg:flex-col lg:gap-2 lg:items-start max-w-[909px] mxl:max-w-full">
                    <h3 className="text-xl font-medium text-blue3">
                      {disabledUrls?.includes(category?.slug) ? (
                        <span className="flex gap-[8px] items-center">
                          {category?.categoryName === "Refrigerators"
                            ? "Refrigerators & Freezers"
                            : category?.categoryName}
                        </span>
                      ) : (
                        <Link
                          className="flex gap-[8px] items-center"
                          href={`/${category?.slug}`}
                          onClick={() => {
                            closePopover();
                            addBreadcrum([categoryBreadcrumb]);
                          }}
                        >
                          {category?.categoryName === "Refrigerators"
                            ? "Refrigerators & Freezers"
                            : category?.categoryName}
                        </Link>
                      )}
                    </h3>

                    <Link
                      href={
                        categoryMap[category?.categoryName]
                          ? `/${categoryMap[category?.categoryName]}`
                          : `/${category?.slug}`
                      }
                      className={`border-black border rounded-20 px-[28px] py-[9px] text-[12px] lg:self-end ${
                        category?.categoryName === "Deals & Clearance"
                          ? "hidden"
                          : ""
                      }`}
                      onClick={() => {
                        closePopover();
                        addBreadcrum([categoryBreadcrumb]);
                      }}
                    >
                      {`Browse All ${category?.categoryName}`}
                    </Link>
                  </div>

                  <div className="pb-[24px] pt-[18px] ">
                    <ul
                      className={
                        category?.id === 350 || category?.id === 418
                          ? "text-ul-row"
                          : category?.id === 389
                          ? "text-ul-row smart-appliances"
                          : "text-ul"
                      }
                    >
                      {category?.subcategories.map((sub, index) => (
                        <div
                          key={sub?.id || `sub-${index}`}
                          className="mb-[15px] pr-[8px]"
                        >
                          {disabledUrls?.includes(sub?.slug) ? (
                            <div
                              key={index}
                              className="text-base text-blue2 mb-2 font-medium flex gap-[6px] items-center"
                            >
                              {sub?.subCategoryName}
                            </div>
                          ) : (
                            <Link
                              href={`/${sub?.slug}`}
                              onClick={() => {
                                closePopover();
                                addBreadcrum([
                                  categoryBreadcrumb,
                                  {
                                    name: sub?.subCategoryName,
                                    url: sub?.slug,
                                  },
                                ]);
                              }}
                              className="text-li"
                            >
                              <h5 className="text-base text-blue2 mb-2 font-medium flex gap-[6px] items-center">
                                {sub?.subCategoryName}
                                <RightArrow width="7px" height="11px" />
                              </h5>
                            </Link>
                          )}

                          {sub?.subcategories2?.length > 0 &&
                            sub?.subcategories2?.map((sub2, idx) => (
                              <li
                                key={idx}
                                className="text-sm text-blue2 mb-2 text-li"
                              >
                                <Link
                                  href={generateHref(
                                    sub2,
                                    `/${sub2?.slug}`,
                                    sub.id
                                  )}
                                  onClick={() => {
                                    closePopover();
                                    addBreadcrum([
                                      categoryBreadcrumb,
                                      {
                                        name: sub?.subCategoryName,
                                        url: sub?.slug,
                                      },
                                      {
                                        name: sub2?.subCategory2Name,
                                        url: sub2?.slug,
                                      },
                                    ]);
                                  }}
                                >
                                  {sub2?.subCategory2Name}
                                </Link>
                              </li>
                            ))}
                        </div>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className=" border-l mt-[25px] border-gray1 flex flex-col gap-6 py-11 pr-5 pl-8 lg:hidden pb-[64px] mxl:hidden">
                  <Link
                    href={bannerHref}
                    className=" flex flex-col max-w-[340px] justify-center relative w-full min-w-340 min-h-107 rounded-xl overflow-hidden px-7 py-3 1280:min-w-[298px] 1280:max-w-[298px]"
                    onClick={() => {
                      closePopover();
                      addBreadcrum([{ name: bannerLabel, url: bannerHref }]);
                    }}
                  >
                    <DynamicImage
                      src={
                        category?.categoryName === "Refrigerators"
                          ? Refrigerators
                          : category?.categoryName === "Dishwashers"
                          ? Dishwashers
                          : category?.categoryName === "Cooking"
                          ? CookingAppliances
                          : category?.categoryName === "Washers & Dryers"
                          ? stockLaundry
                          : category?.categoryName === "Smart Appliances"
                          ? smartAppliances
                          : category?.categoryName === "Deals & Clearance"
                          ? Appliances
                          : ""
                      }
                      alt="image"
                      fill
                      className="object-cover backdrop-brightness-50"
                    />
                    <div className="backdrop-brightness-50 absolute top-0 bottom-0 right-0 left-0" />
                    <h5 className="text-base text-white	relative mb-[6px]">
                      Browse All
                    </h5>
                    <h3 className="relative text-[20px]  leading-[26px] text-white font-bold">
                      {bannerLabel}
                    </h3>
                  </Link>
                  <Link
                    href="/luxury-appliances"
                    className=" flex flex-col justify-center relative w-full min-w-340 min-h-107 rounded-xl overflow-hidden px-7 py-3 1280:min-w-[298px] 1280:max-w-[298px]"
                    onClick={closePopover}
                  >
                    <DynamicImage
                      src={LuxuryAppliances}
                      alt="image"
                      fill
                      className="object-cover backdrop-brightness-50"
                    />
                    <div className="backdrop-brightness-50 absolute top-0 bottom-0 right-0 left-0" />
                    <h5 className="text-base text-white	relative mb-[6px]">
                      Explore our
                    </h5>
                    <h3
                      className="relative text-[20px]  leading-[26px] text-white font-bold
                        "
                    >
                      Luxury Appliances
                    </h3>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="bg-black/20 h-full"
              onClick={closePopover}
              onMouseEnter={() => setOpen(false)}
            ></div>
          </div>
        </PopoverContent>
      )}
    </Popover>
  );
};

export const RenderCategoriesForMobile = ({
  category,
  generateHref,
  callBack,
  className,
}) => {
  const [value, setValue] = useState("");

  const categoryMap = {
    Refrigerators: "refrigerators-freezers",
    Dishwashers: "dishwashers/all-dishwashers",
    Cooking: "cooking/all-cooking",
    "Washers & Dryers": "laundry/all-laundry",
  };

  const categoryBreadcrumb = {
    name:
      category?.categoryName === "Refrigerators"
        ? "Refrigerators & Freezers"
        : category?.categoryName,
    url: category?.slug,
  };
  const dispatch = useDispatch();
  const addBreadcrum = (category) => {
    dispatch(AddNewBreadcrum(category));
  };
  
  return (
    <>
      {category?.subCategoryCounts === 0 ? (
        <div className="px-6">
          <div
            className={cn(
              "flex items-center space-x-2 w-full  border-b border-gray1 py-2",
              className
            )}
          >
            <DynamicImage
              alt={category?.categoryName}
              src={category?.categoryImages?.[0]?.url || NoImage.src}
              width={25}
              height={25}
              className="min-h-[25px] max-h-[25px]"
            />
            <Link href={`/${category?.slug}`} onClick={()=> {
              callBack();
              addBreadcrum([categoryBreadcrumb]);
            }}>
              <h5 className="text-base  font-medium flex gap-[6px] items-center lg:font-normal">
                {category?.categoryName}
              </h5>
            </Link>
          </div>
        </div>
      ) : (
        <Accordion
          type="single"
          collapsible
          className="w-full px-6"
          onValueChange={setValue}
          value={value}
        >
          <AccordionItem value={`item-${category.id}`}>
            <AccordionTrigger
              className={cn("font-normal py-2  ", className)}
              iconHeight="5px"
              iconWidth="10px"
            >
              <div className="flex items-center space-x-2">
                <DynamicImage
                  alt={category?.categoryName}
                  src={category?.categoryImages?.[0]?.url || NoImage.src}
                  width={20}
                  height={20}
                  className="min-h-[20px] max-h-[20px]"
                />
                <div>{category?.categoryName}</div>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              {category?.subcategories.length > 0 && (
                <div>
                  <div className="container bg-white lg:h-full">
                    <div className="flex max-w-[1440px] my-0 mx-auto ">
                      <div className=" flex-1 max-w-932 border-r border-gray1 pr-7 pb-4 lg:pr-0 lg:border-0 flex flex-col-reverse ">
                        {category?.categoryName !== "Deals & Clearance" && (
                          <div>
                            <div className=" flex justify-between items-center pt-5  lg:py-3 lg:pb-0 ">
                              <Link
                                href={
                                  categoryMap[category?.categoryName]
                                    ? `/${categoryMap[category?.categoryName]}`
                                    : `/${category?.slug}`
                                }
                                className=" border-black border rounded-20 px-5 py-p9 lg:text-[14px]"
                                onClick={()=> {
                                  callBack();
                                  addBreadcrum([categoryBreadcrumb]);
                                }}
                              >
                                {`Browse All ${category?.categoryName}`}
                              </Link>
                            </div>
                          </div>
                        )}
                        <ul>
                          {category?.subcategories.map((sub, index) => (
                            <li
                              key={index}
                              className=" inline-block float-start pr-4 w-[225px] lg:w-full"
                            >
                              <Link href={`/${sub?.slug}`} onClick={()=> {
                               callBack(); 
                               addBreadcrum([
                                categoryBreadcrumb,
                                {
                                  name: sub?.subCategoryName,
                                  url: sub?.slug,
                                },
                              ]);
                              }}>
                                <h5 className="text-base text-blue2 mb-2 font-medium flex gap-[6px] items-center">
                                  {sub?.subCategoryName}
                                  <RightArrow width="7px" height="11px" />
                                </h5>
                              </Link>
                              {sub?.subcategories2?.length > 0 &&
                                sub?.subcategories2?.map((sub2, idx) => (
                                  <ul key={idx}>
                                    <li className="text-sm text-blue2 mb-2">
                                      <Link
                                        href={sub2?.subCategory2Name === 'In-Stock'? 'next-day-delivery' : generateHref(
                                          sub2,
                                          `/${sub2?.slug}`,
                                          sub.id
                                        )}
                                        onClick={()=> {
                                          callBack();
                                          addBreadcrum([
                                            categoryBreadcrumb,
                                            {
                                              name: sub?.subCategoryName,
                                              url: sub?.slug,
                                            },
                                            {
                                              name: sub2?.subCategory2Name,
                                              url: sub2?.slug,
                                            },
                                          ]);
                                        }}
                                        
                                      >
                                        {sub2?.subCategory2Name}
                                      </Link>
                                    </li>
                                  </ul>
                                ))}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      )}
    </>
  );
};
